export default __webpack_public_path__ + "static/media/sun.c24e67d1.gif";